import React, { useState } from 'react';
import { connect } from 'react-redux';
import { Modal } from 'reactstrap';
import DSCohortAddEditForm from './DSCohortAddEditForm';
import DSCohortEditDialogHeader from './DSCohortEditDialogHeader';

const DSCohortEditDialog = ({ show, onHide, id, isEdit, rtl }) => {
  const [modal, setModal] = useState({
    isOpen: show,
    title: `${isEdit ? 'Edit' : 'Add'}  DS Cohort`,
    hide: onHide,
  });

  return (
    <Modal
      isOpen={show}
      toggle={modal.hide}
      modalClassName={`${rtl.direction}-support`}
      className="modal-dialog--primary modal-dialog--header modal-edit-dialog"
    >
      <DSCohortEditDialogHeader modal={modal} />
      <DSCohortAddEditForm modal={modal} isEdit={isEdit} id={+id} />
    </Modal>
  );
};

export default connect((state) => ({
  rtl: state.rtl,
}))(DSCohortEditDialog);
